export default __webpack_public_path__ + "static/media/geo-alt-header.576ffad6.svg";